import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  quote: 'Antes de conocer El Oráculo muchas veces terminaba improvisando cuando un paciente respondía con un “No sé”. Hoy siempre tengo una forma clara de continuar la sesión sin perder profundidad.',
  name: 'Andrea P.',
  role: 'Psicóloga Clínica',
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/18969b23-92bb-47ac-bfeb-5ace2a4051f7.jpg'
}, {
  quote: 'Pensé que sería otro PDF más. Me equivoqué. Es una herramienta que consulto prácticamente todos los días antes de comenzar mis sesiones.',
  name: 'Carlos M.',
  role: 'Psicoterapeuta',
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/aefc22fb-3a0a-41f5-9d5a-adc3949b0c4a.jpg'
}, {
  quote: 'El Tomo 4 cambió completamente mi forma de trabajar con pacientes resistentes. Hoy me siento mucho más seguro conduciendo sesiones complejas.',
  name: 'Mariana G.',
  role: 'Terapeuta Integrativa',
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/771356b0-b999-4530-84a7-f941b0384f0b.jpg'
}, {
  quote: 'Lo que más me sorprendió fue el Tomo 6. Nunca imaginé que el cierre de una sesión podía generar tanto impacto en el proceso terapéutico.',
  name: 'Sofía R.',
  role: 'Psicóloga',
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/967d93d0-684b-4b25-a78a-9f059cc37469.jpg'
}];
export function TestimonialsSection() {
  return <section className="bg-[#faf6fb] px-4 py-14" data-id="element-225" data-mp="274x5ahqy67d7">
      <div className="mx-auto max-w-md" data-id="element-226" data-mp="2m0w9vieulpdl">
        <h2 className="text-center font-display text-3xl font-bold leading-tight text-plum" data-id="element-227" data-mp="2m1nxo727eitb">
          Lo que opinan otros terapeutas
        </h2>

        <div className="mt-8 space-y-4" data-id="element-228" data-mp="1ang7xjsjvb3">
          {testimonials.map((t, i) => <motion.div key={t.name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="rounded-2xl border border-purple-100 bg-white p-5 shadow-sm" data-id="element-229" data-mp="1crsb2rug0mg" data-mpi={i}>
              <div className="flex gap-0.5 text-amber-400" data-id="element-230" data-mp="dcf0eq5up3a0">
                {Array.from({
              length: 5
            }).map((_, s) => <StarIcon key={s} className="h-4 w-4 fill-current" data-id="element-231" data-mp="ib00mpl3rmyg" data-mpi={s} />)}
              </div>
              <p className="mt-3 text-sm italic leading-relaxed text-plum/80" data-id="element-232" data-mp="3guzwexrk9ymn">“{t.quote}”</p>
              <div className="mt-4 flex items-center gap-3" data-id="element-233" data-mp="3lttbgumhxxox">
                <img src={t.img} alt={t.name} className="h-12 w-12 rounded-full object-cover ring-2 ring-pink/30" loading="lazy" data-id="element-234" data-mp="3qrurt7sjfiwp" />
                <div data-id="element-235" data-mp="2y3p6aitntpvt">
                  <p className="text-sm font-bold text-plum" data-id="element-236" data-mp="2y2e4gojrys7c">{t.name}</p>
                  <p className="text-xs text-magenta" data-id="element-237" data-mp="331qol1j9hl68">{t.role}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}